export function exhaustiveCheck(_param: never): never {
    /* nothing */
    throw new Error(`exhaustive check is failed: ${JSON.stringify(_param)}`);
}

